import { render, staticRenderFns } from "./juridical.vue?vue&type=template&id=09793c46&scoped=true"
import script from "./juridical.vue?vue&type=script&lang=js"
export * from "./juridical.vue?vue&type=script&lang=js"
import style0 from "./juridical.vue?vue&type=style&index=0&id=09793c46&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09793c46",
  null
  
)

export default component.exports